import React from "react";
import SectionCard from "./SectionCard";

export default function UnitStatsAndWarnings({ unitWarnings }) {
  return (
    <SectionCard
      title="Automatische Warnungen"
      subtitle="Wichtige Hinweise nur für diese Unit"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {unitWarnings.map((warning, index) => (
          <div
            key={`${warning.text}-${index}`}
            className={`rounded-2xl border p-4 ${
              warning.tone === "rose"
                ? "border-red-500/20 bg-red-500/10"
                : warning.tone === "slate"
                  ? "border-black/10 bg-slate-100 dark:border-white/[0.07] dark:bg-[#111520]"
                  : warning.tone === "emerald"
                    ? "border-green-500/20 bg-green-500/10"
                    : "border-amber-500/20 bg-amber-500/10"
            }`}
          >
            <p
              className={`text-sm font-medium ${
                warning.tone === "rose"
                  ? "text-red-400"
                  : warning.tone === "slate"
                    ? "text-[#eef2ff]"
                    : warning.tone === "emerald"
                      ? "text-green-400"
                      : "text-amber-400"
              }`}
            >
              {warning.text}
            </p>
          </div>
        ))}

        {unitWarnings.length === 0 && (
          <div className="rounded-2xl border border-green-500/20 bg-green-500/10 p-4">
            <p className="text-sm font-medium text-green-400">
              Keine kritischen Warnungen für diese Unit
            </p>
          </div>
        )}
      </div>
    </SectionCard>
  );
}
